import { render, staticRenderFns } from "./FormRol.vue?vue&type=template&id=ffb95e18&scoped=true&"
import script from "./FormRol.vue?vue&type=script&lang=js&"
export * from "./FormRol.vue?vue&type=script&lang=js&"
import style0 from "./FormRol.vue?vue&type=style&index=0&id=ffb95e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb95e18",
  null
  
)

export default component.exports